export default __webpack_public_path__ + "static/media/gold.07a382aa.mp3";